// This file is automatically generated. Do not edit manually.

import { ObjectAttributeField } from "src/api/generated/erp/common/objectAttributes/model/objectAttributeField";
import { ConfigurationPropertyValueFilter } from "src/api/generated/erp/configurator/propertyValueFiltering/configurationPropertyValueFilter";
import { ServerSideDataModelRequest } from "src/api/generated/common/dataGrids/serverSideDataModelRequest";
import { ServerSideDataModelResult } from "src/api/generated/common/dataGrids/serverSideDataModelResult";
import { ProductionLineView } from "src/api/generated/erp/db/types/tables/productionLineView";
import { IsoDateTimeString } from "src/types/dateTime";
import { IsoDateString } from "src/types/dateTime";
import { ShopOrderMaterialState } from "src/api/generated/erp/db/types/enums/shopOrderMaterialState";
import { PreviousOperationResolutionMode } from "src/api/generated/erp/db/types/enums/previousOperationResolutionMode";
import { ShopOrderViewShopOrderBatchState } from "src/api/generated/erp/db/types/enums/shopOrderViewShopOrderBatchState";
import { ShopOrderState } from "src/api/generated/erp/db/types/enums/shopOrderState";
import { IsoTimeString } from "src/types/dateTime";
import { ShopOrderSourceType } from "src/api/generated/erp/db/types/enums/shopOrderSourceType";
import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace AddShopOrdersToBatchDataGridApi {
	export async function getAttributeFilterFields(args: {
		siteId: number;
		productionLineId: number | null | undefined;
		attributeFieldIds: Array<number>;
		onlyAlreadyConnectedParts?: boolean;
		shopOrderBatchId?: number | null | undefined;
	}): Promise<Array<ObjectAttributeField>> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/production/shopOrderBatch/getAttributeFilterFields",
			method: "POST",
			data: {
				siteId: args.siteId,
				productionLineId: args.productionLineId,
				attributeFieldIds: args.attributeFieldIds,
				onlyAlreadyConnectedParts: args.onlyAlreadyConnectedParts,
				shopOrderBatchId: args.shopOrderBatchId,
			},
		});
		return response as Array<ObjectAttributeField>;
	}

	export async function getShopOrdersToAdd(args: {
		siteId?: number | null | undefined;
		searchQuery?: string;
		productionLineId?: number | null | undefined;
		propertyValueFilters?: Array<ConfigurationPropertyValueFilter>;
		attributeValueFilters?: Array<AddShopOrdersToBatchDataGridApi_AttributeFilter>;
		onlyAlreadyConnectedParts?: boolean;
		shopOrderBatchId?: number | null | undefined;
		dataModelRequest: ServerSideDataModelRequest;
	}): Promise<AddShopOrdersToBatchDataGridApi_ShopOrdersToAddData> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/production/shopOrderBatch/getShopOrdersToAdd",
			method: "POST",
			data: {
				siteId: args.siteId,
				searchQuery: args.searchQuery,
				productionLineId: args.productionLineId,
				propertyValueFilters: args.propertyValueFilters,
				attributeValueFilters: args.attributeValueFilters,
				onlyAlreadyConnectedParts: args.onlyAlreadyConnectedParts,
				shopOrderBatchId: args.shopOrderBatchId,
				dataModelRequest: args.dataModelRequest,
			},
		});
		return response as AddShopOrdersToBatchDataGridApi_ShopOrdersToAddData;
	}

	export async function addSelectedRowsToBatch(args: {
		shopOrderBatchId: number;
		selectedShopOrderIds: Array<number>;
	}): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/production/shopOrderBatch/addSelectedRowsToBatch",
			method: "POST",
			data: {
				shopOrderBatchId: args.shopOrderBatchId,
				selectedShopOrderIds: args.selectedShopOrderIds,
			},
		});
		return response as void;
	}
}

export interface AddShopOrdersToBatchDataGridApi_AttributeFilter {
	attributeFieldId: number;
	attributeValue: string;
}

export interface AddShopOrdersToBatchDataGridApi_ShopOrdersToAddData {
	data: ServerSideDataModelResult<AddShopOrdersToBatchDataGridApi_ShopOrderDto>;
	productionLineOptions: Array<ProductionLineView>;
}

export interface AddShopOrdersToBatchDataGridApi_ShopOrderDto {
	tenantCustomColumn1: string | null | undefined;
	actualBeginDate: IsoDateTimeString | null | undefined;
	actualEndDate: IsoDateTimeString | null | undefined;
	automaticClose: boolean;
	cancelledDate: IsoDateTimeString | null | undefined;
	capacityQuantity: number;
	capacityUnit: string;
	capacityUnitId: number;
	catalogPartId: number;
	catalogPartRevisionId: number;
	completedQuantity: number;
	configurationContentHash: string | null | undefined;
	configurationOrPartDescription: string | null | undefined;
	costTrackingStartedAt: IsoDateTimeString | null | undefined;
	createdBy: string;
	createdByUserId: number;
	createdDate: IsoDateTimeString;
	creationDate: IsoDateTimeString;
	customerName: string | null | undefined;
	customerOrderId: number | null | undefined;
	customerOrderLineId: number | null | undefined;
	customerOrderLineMark: string | null | undefined;
	customerOrderOrderReference: string | null | undefined;
	deliveryAddress_1: string | null | undefined;
	deliveryCity: string | null | undefined;
	deliveryPostalCode: string | null | undefined;
	demandDate: IsoDateString | null | undefined;
	includeBomOnWorkInstructionsPrint: boolean | null | undefined;
	lastUpdated: IsoDateTimeString;
	materialCost: number;
	materialState: ShopOrderMaterialState;
	note: string | null | undefined;
	packageInfo: string | null | undefined;
	partAcquisitionRemark: string;
	partAggregateOnShopOrder: boolean;
	partConfigurationDescription: string | null | undefined;
	partConfigurationId: number | null | undefined;
	partDescription_1: string;
	partDescription_2: string;
	partEstimatedProductionTimeHours: number | null | undefined;
	partId: number;
	partIsConfigurable: boolean;
	partListPrinted: IsoDateTimeString | null | undefined;
	partLongName: string | null | undefined;
	partNo: string;
	partRevision: number;
	partRevisionId: number;
	partRevisionNote: string;
	partSalesRemark: string;
	partUnit: string;
	plannedBeginDate: IsoDateTimeString | null | undefined;
	plannedEndDate: IsoDateTimeString | null | undefined;
	previousOperationResolutionMode: PreviousOperationResolutionMode;
	productionLineGroup: string;
	productionLineGroupId: number;
	productionLineId: number;
	productionLineName: string;
	productionLineOnlyBatchPlanning: boolean;
	productionLineOperationDescription: string | null | undefined;
	productionLineOperationId: number | null | undefined;
	productionLineOperationNo: string | null | undefined;
	quantity: number;
	releasedDate: IsoDateTimeString | null | undefined;
	remainingQuantity: number;
	shopOrderBatchId: number | null | undefined;
	shopOrderBatchName: string | null | undefined;
	shopOrderBatchState: ShopOrderViewShopOrderBatchState | null | undefined;
	shopOrderId: number;
	shopOrderNote: string | null | undefined;
	shopOrderState: ShopOrderState;
	siteId: number;
	siteName: string;
	siteProductionPlanningDefaultDurationSeconds: number | null | undefined;
	siteProductionPlanningDefaultStartTime: IsoTimeString | null | undefined;
	siteShowFullOperationProductionBom: boolean;
	source: ShopOrderSourceType;
	sourceActivityName: string | null | undefined;
	sourceDescription: string;
	sourceId: number | null | undefined;
	sourceProjectActivityId: number | null | undefined;
	sourceProjectActivityMaterialId: number | null | undefined;
	sourceProjectActivityMaterialMark: string | null | undefined;
	sourceProjectActivityMaterialParentMaterialId: number | null | undefined;
	sourceProjectDescription: string | null | undefined;
	sourceProjectId: number | null | undefined;
	sourceShopOrderId: number | null | undefined;
	sourceSubProjectDescription: string | null | undefined;
	sourceSubProjectId: number | null | undefined;
	totalCost: number;
	totalEstimatedProductionTimeHours: number | null | undefined;
	weight: number | null | undefined;
	workCost: number;
	workInstructionPrinted: IsoDateTimeString | null | undefined;
}
